import { render, staticRenderFns } from "./about2.vue?vue&type=template&id=28091865&"
import script from "./about2.vue?vue&type=script&lang=js&"
export * from "./about2.vue?vue&type=script&lang=js&"
import style0 from "./about2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports